/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- HELPERS --------------- ++++++++++ */
const directions = {
    negative: {
        background: 'rgb(254, 242, 248)',
        font: 'rgb(252, 79, 161)'
    },
    positive: {
        background: 'rgb(243, 251, 244)',
        font: 'rgb(102, 206, 110)'
    }
}



/* ++++++++++ --------------- CHANGE BADGE : STYLES --------------- ++++++++++ */
export default {
    changebadge: {
        width: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        fontSize: pxToEm(12),
        fontWeight: '600',
        padding: pxToEm(6),
        borderRadius: pxToEm(18),
        background: props => directions[props.direction].background ,
        color: props => directions[props.direction].font,
        '& .icon': {
            fontSize: pxToEm(12),
            marginRight: pxToEm(4)
        }

    }
};
